import { createRouter, createWebHistory } from 'vue-router';

import Home from './pages/Home.vue';
import Features from './pages/Features.vue';
const routes = [
  {
    name: '',
    path: '/',
    component: Home,
  },
  {
    name: 'home',
    path: '/home',
    component: Home,
  },
  {
    name: 'features',
    path: '/features',
    component: Features,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    document.getElementById('app').scrollIntoView();
  },
});

export default router;
